import { render } from "./folder.vue?vue&type=template&id=4c029023&scoped=true"
import script from "./folder.vue?vue&type=script&lang=js"
export * from "./folder.vue?vue&type=script&lang=js"

import "./folder.vue?vue&type=style&index=0&id=4c029023&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c029023"],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar/folder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c029023"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c029023', __exports__)) {
    console.log('reload')
    api.reload('4c029023', __exports__)
  }
  
  module.hot.accept("./folder.vue?vue&type=template&id=4c029023&scoped=true", () => {
    console.log('re-render')
    api.rerender('4c029023', render)
  })

}


export default __exports__